var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._b({attrs:{"src":_vm.realsrc}},'img',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }